export const jobLossCategories = [
    { label: 'Business is slow/Lack of work', id: 'Business is slow/Lack of work' },
    {
        label: 'I did not meet the goals set for me by my employer',
        id: 'I did not meet the goals set for me by my employer'
    },
    { label: 'I missed too much work', id: 'I missed too much work' },
    { label: 'I reassigned/I re-located', id: 'I reassigned/I re-located' },
    { label: 'I violated a company policy or rule', id: 'I violated a company policy or rule' },
    { label: 'I was let go due to misconduct', id: 'I was let go due to misconduct' },
    { label: 'My company downsized/My business closed', id: 'My company downsized/My business closed' },
    { label: 'My contract ended', id: 'My contract ended' },
    { label: 'Seasonal, annual or regularly scheduled layoff', id: 'Seasonal, annual or regularly scheduled layoff' },
    { label: 'Other', id: 'Other' }
];
